import { useTranslation } from 'react-i18next';
import type { FullSyncPreview } from '@/shared/api';
import { formatMoney } from '@/shared/lib/format';

export function FullSyncPreviewDetails({
  preview,
  currency,
}: {
  preview: FullSyncPreview;
  currency: string;
}) {
  const { t } = useTranslation();
  return (
    <>
      <dl className="grid grid-cols-2 gap-3 text-sm">
        <Stat
          label={t('admin.ari.fullSync.horizon')}
          value={t('admin.ari.fullSync.dayCount', { count: preview.horizonDays })}
        />
        <Stat
          label={t('admin.ari.fullSync.basePrice')}
          value={formatMoney(preview.basePrice, currency)}
        />
        <Stat label={t('admin.ari.fullSync.blockedRanges')} value={String(preview.blockedRanges)} />
        <Stat
          label={t('admin.ari.fullSync.automationDays')}
          value={t('admin.ari.fullSync.dayCount', { count: preview.automationDays })}
        />
        <Stat
          label={t('admin.ari.fullSync.manualDays')}
          value={t('admin.ari.fullSync.dayCount', { count: preview.manualDays })}
        />
        <Stat
          label={t('admin.ari.fullSync.prefillDays')}
          value={t('admin.ari.fullSync.dayCount', { count: preview.prefillDays })}
        />
        {preview.daysWithoutPrice > 0 && (
          <p className="text-sealwax col-span-2 text-xs" role="alert">
            {t('admin.ari.fullSync.missingPrice', {
              count: preview.daysWithoutPrice,
              dates: preview.firstDaysWithoutPrice.join(', '),
              more: preview.daysWithoutPrice > preview.firstDaysWithoutPrice.length ? ' …' : '',
            })}
          </p>
        )}
      </dl>
      <p className="text-ink-soft mt-3 text-xs">{t('admin.ari.fullSync.sourceOverlapHint')}</p>
    </>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <dt className="text-ink-faint text-[10px] uppercase tracking-wider">{label}</dt>
      <dd className="text-ink font-medium tabular-nums">{value}</dd>
    </div>
  );
}
